'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = require('redux');

var _index = require('./reducers/index');

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Redux Store
 * @type {Object}
 */
/* eslint-disable no-underscore-dangle */
var store = (0, _redux.createStore)(_index2.default);
/* eslint-enable */
exports.default = store;


//////////////////
// WEBPACK FOOTER
// ./~/@univision/fe-commons/dist/store/store.js
// module id = 65
// module chunks = 35783957827783 71851226274881